import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans payroll (clés `payroll.*`).
 *
 * Les clés vivent dans le fragment `features/payroll/i18n/payroll.json`
 * et seront fusionnées dans `src/locales/*.json` lors du câblage final
 * par le coordinateur : tant que la fusion n'est pas faite,
 * `TFunctionType` (dérivé de fr.json) ne les connaît pas encore, d'où
 * le cast.
 */
export const usePayrollTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
